/**
 * All remote images
 */
export const images = {
    ic24Apple: 'ic_24_apple.svg',
    ic24Google: 'ic_24_google.svg',
    ic72ProductLogo: 'ic_72_product_logo.svg',
    ic90AppStore: 'ic_90_app_store.svg',
    ic90GooglePlay: 'ic_90_google_play.svg',
    ic132AppStore: 'ic_132_app_store.svg',
    ic132GooglePlay: 'ic_132_google_play.svg',
    ill168Staking: 'ill_168_staking.png',
    ill168ZeroComission: 'ill_168_zero_comission.png',
    ill210Staking: 'ill_210_staking.png',
    ill210Selfie: 'ill_210_selfie.png',
    ill210Referral: 'ill_210_referral.png',
    arrow: 'arrow.svg',
    card: 'card.png',
    cards: 'cards.png',
    smallCard: 'small_card.png',
    chartNoData: 'chart-no-data.svg',
    logo: 'logo.svg',
    // TODO redesign: rename after release, delete old
    logoNew: 'logo_new.svg',
    primerSelectApplePayMethod: 'primer_select_apple_pay_method.svg',
    primerSelectCardMethod: 'primer_select_card_method.svg',
    primerSelectGooglePayMethod: 'primer_select_google_pay_method.svg',
    primerVisaMethod: 'primer_select_visa_method.svg',
    primerMastercardMethod: 'primer_select_mastercard_method.svg',
    notFound: 'not_found.svg',
    logoSquare: 'logo_square.svg',
    logoFreewallet: 'logo_freewallet.svg',
    newVirtualCard: 'new_virtual_card.png',
    fiat: 'ic_60_fiat.svg',
    crypto: 'ic_60_crypto.svg',
    onboardingBanner: 'onboarding_banner.png',
}

/**
 * Remote additional paths
 */
export const additionalPaths = {
    paymentProviders: 'payment_providers',
    paymentMethods: 'payment_methods',
}
